module.exports = __webpack_public_path__ + "images/about-us-header@2x.5e6b6065e15f78d02fb97bd1563342dd.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/about-us-header@2x.jpg
// module id = 981
// module chunks = 0